import { render, staticRenderFns } from "./AutomaticCarousel.vue?vue&type=template&id=dfa30306&scoped=true"
import script from "./AutomaticCarousel.vue?vue&type=script&lang=js"
export * from "./AutomaticCarousel.vue?vue&type=script&lang=js"
import style0 from "./AutomaticCarousel.vue?vue&type=style&index=0&id=dfa30306&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfa30306",
  null
  
)

export default component.exports